// Shared eligibility helper — Selective Entry / Selectives / Scholarship / VCE Selective.
const ELIGIBLE_KEYS = ['selective entry', 'selectives', 'vce selective', 'scholarship'];

export function isEligibleSelectiveProgram(planProgram) {
  if (!planProgram) return false;
  const s = String(planProgram).toLowerCase();
  return ELIGIBLE_KEYS.some(k => s.includes(k));
}
